<template>
    <footer class="l-footer">
        <div class="l-footer__menu">
            <ul>
                <li><router-link :to="{ name: 'news.list' }">{{ $t('LABEL_NEWS') }}</router-link></li>
                <li><router-link :to="{ name: 'user.terms' }">{{ $t('LABEL_MERCHANT_TERM_OF_USE') }}</router-link></li>
                <li><router-link :to="{ name: 'privacy.policy' }">{{ $t('LABEL_PRIVACY_POLICY') }}</router-link></li>
                <li><router-link :to="{ name: 'contact.us' }">{{ $t('LABEL_ENQUIRY') }}</router-link></li>
            </ul>
        </div>
        <address>&copy;&nbsp;hubsynch&nbsp;Inc.</address>
    </footer>
</template>